import { Component, OnInit } from '@angular/core';
import { DataTable, LazyLoadEvent, Message, SelectItem } from 'primeng/primeng';
import { NotificationContentType } from '../../models/inModels/MessageModel';
import { StorageService } from '../../services/system/storage.service';
import { Router } from '@angular/router';
import { BoardThemeResponse } from '../../models/inModels/BoardTheme';
import { BoardThemeService } from '../../services/board-themes/board-themes.service';

@Component({
  selector: 'app-board-themes',
  templateUrl: './board-themes.component.html'
})
export class BoardThemesComponent implements OnInit {
	rows: SelectItem[];
  	items: BoardThemeResponse[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	isEditMode: boolean = false;
	constructor(private service: BoardThemeService,
		public storageService: StorageService,
		private router: Router) {
			this.loading = true;
			this.rows = [];
			this.rows.push({ label: '10', value: 10 });
			this.rows.push({ label: '25', value: 25 });
			this.rows.push({ label: '50', value: 50 });
			this.selectedRows = 10;
	}

	ngOnInit() {
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	edit(theme: BoardThemeResponse) {
		this.router.navigate(['board-themes/edit', theme.Id]);
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
        		this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/board-themes/board-themes.component.ts